import * as React from 'react'

import AuthContext from "../../context/AuthContext";

import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'

const FacebookSocialAuth = () => {
    const { loginFacebookUser } = React.useContext(AuthContext);

    const responseFacebook = async (response: any) => {
        await loginFacebookUser(response.accessToken);
      };

    return (
        <div>
            <FacebookLogin
                textButton='Facebook'
                appId='654501796153106'
                fields='name,email'
                callback={responseFacebook}
                render={renderProps => (
                    <div id="customBtn" className="customGPlusSignIn" onClick={renderProps.onClick}>
                        <span className="iconFB" ></span>
                        <span className="buttonText">Facebook</span>
                    </div>
                )}
            />
        </div>
    )
}

export default FacebookSocialAuth